module.exports = __webpack_public_path__ + "static/media/singleStickers.3076b255.jpg";